import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import type { GetElementalParentsQuery } from '~~/src/api/elementals'
import { getElementalParents } from '~~/src/api/elementals'
import type { GetReturn } from '~~/src/types/utils'

export const useGetElementalParentsQuery = (
  args: {
    query: MaybeRef<GetElementalParentsQuery>
  },
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getElementalParents>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getElementalParents>, Error> => {
  return useQuery({
    queryKey: ['elemental-parents', args.query] as const,
    queryFn: async ({ queryKey }) => {
      const [_, query] = queryKey
      const data = await getElementalParents(query)
      return data
    },
    ...options,
  })
}
